module.exports = __webpack_public_path__ + "static/media/sad.2a7a4f35.svg";